/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const getMyNextActionParamsDriverDefault = `auto`;
export const GetMyNextActionParams = zod.object({
  driver: zod
    .enum(['auto', 'appointment', 'task', 'approval'])
    .default(getMyNextActionParamsDriverDefault)
    .describe(
      'Source of the next action. `auto` returns the highest-ranked item across all sources: an appointment in the next 24 h, then a pending approval, then a later appointment, then a task.',
    ),
});

export type GetMyNextActionParams = zod.input<typeof GetMyNextActionParams>;
export type GetMyNextActionParamsOutput = zod.output<typeof GetMyNextActionParams>;
